// Vimeo Fix Script - Forces Vimeo videos to load properly
(function() {
  'use strict';
  
  // Function to fix Vimeo iframes
  function fixVimeoIframes() {
    const iframes = document.querySelectorAll('iframe[data-suppressedsrc*="vimeo.com"], iframe[data-cmp-src*="vimeo.com"]');
    
    iframes.forEach(iframe => {
      // Check if iframe has blank src and has Vimeo URL in data attributes
      if (iframe.src === 'about:blank' || iframe.src === '') {
        const vimeoUrl = iframe.getAttribute('data-suppressedsrc') || 
                        iframe.getAttribute('data-cmp-src') || 
                        iframe.getAttribute('data-src');
        
        if (vimeoUrl && vimeoUrl.includes('vimeo.com')) {
          console.log('Fixing Vimeo iframe:', vimeoUrl);
          iframe.src = vimeoUrl;
          
          // Remove lazy loading classes that might interfere
          iframe.classList.remove('cmplazyload', '_iub_cs_activate');
          
          // Ensure iframe is visible
          iframe.style.opacity = '1';
          iframe.style.visibility = 'visible';
        }
      }
    });
  }
  
  // Run immediately
  fixVimeoIframes();
  
  // Run on DOM changes (for dynamically loaded content)
  const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        shouldCheck = true;
      }
    });
    
    if (shouldCheck) {
      setTimeout(fixVimeoIframes, 100);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Run on window load
  window.addEventListener('load', fixVimeoIframes);
  
  // Run on scroll (for lazy loading)
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(fixVimeoIframes, 100);
  });
  
})();
